import { render } from "./SetupAuthenticatorPage.vue?vue&type=template&id=ca9d2ea8&scoped=true"
import script from "./SetupAuthenticatorPage.vue?vue&type=script&lang=js"
export * from "./SetupAuthenticatorPage.vue?vue&type=script&lang=js"

import "./SetupAuthenticatorPage.vue?vue&type=style&index=0&id=ca9d2ea8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca9d2ea8"]])

export default __exports__